/**
 * Delivery Date Selector Component
 *
 * Berechnet und zeigt automatisch das nächste verfügbare Lieferdatum an
 */

// Éviter la double déclaration si le script est chargé plusieurs fois
if (typeof window.DeliveryDateSelector === 'undefined') {

class DeliveryDateSelector {
  constructor(element) {
    this.element = element;
    this.selectedDateDisplay = element.querySelector('[data-js-selected-date]');
    this.hiddenInput = element.querySelector('[data-js-delivery-input]');

    // Standardkonfiguration
    // Dynamic minDays: before 12:00 = 1 day, after 12:00 = 2 days
    const currentHour = new Date().getHours();
    const dynamicMinDays = currentHour < 12 ? 1 : 2;

    this.config = {
      minDays: parseInt(element.dataset.minDays) || dynamicMinDays,
      deliveryDays: [1, 2, 3, 4, 5, 6] // Montag bis Samstag
    };

    this.init();
  }

  init() {
    // Frühestes verfügbares Lieferdatum berechnen
    const selectedDate = this.calculateEarliestDeliveryDate();
    
    // Anzeige aktualisieren
    this.updateSelectedDateDisplay(selectedDate);
    
    // Datum im versteckten Feld setzen
    if (this.hiddenInput) {
      this.hiddenInput.value = this.formatDateForInput(selectedDate);
    }
  }

  calculateEarliestDeliveryDate() {
    const today = new Date();
    let candidateDate = new Date(today);
    candidateDate.setDate(candidateDate.getDate() + this.config.minDays);

    // Nächsten verfügbaren Liefertag finden
    while (!this.isDeliveryDay(candidateDate)) {
      candidateDate.setDate(candidateDate.getDate() + 1);
    }

    return candidateDate;
  }

  isDeliveryDay(date) {
    const dayOfWeek = date.getDay();
    // Sonntag (0) in 7 umwandeln für Liquid-Format
    const adjustedDay = dayOfWeek === 0 ? 7 : dayOfWeek;
    return this.config.deliveryDays.includes(adjustedDay);
  }

  updateSelectedDateDisplay(date) {
    if (this.selectedDateDisplay) {
      this.selectedDateDisplay.textContent = this.formatDateForDisplay(date);
    }
  }

  formatDateForInput(date) {
    return date.toISOString().split('T')[0];
  }

  formatDateForDisplay(date) {
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

}

// Auto-Initialisierung
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-js-delivery-selector]').forEach(element => {
    new DeliveryDateSelector(element);
  });
});

// Neuinitialisierung für dynamisch geladene Inhalte (AJAX, etc.)
document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('[data-js-delivery-selector]').forEach(element => {
    if (!element.hasAttribute('data-delivery-initialized')) {
      new DeliveryDateSelector(element);
      element.setAttribute('data-delivery-initialized', 'true');
    }
  });
});

// Export für externe Nutzung
window.DeliveryDateSelector = DeliveryDateSelector;

} // Fin de la protection contre la double déclaration